import type { TelemetryPort } from '@core/domain/ports/driven/TelemetryPort.ts';
import type { ShellCorePorts } from '@src/core/bootstrap/ShellPorts.ts';
import type { AuthApplicationPort } from '@src/modules/auth/domain/ports/AuthApplicationPort.ts';
import { isSnapshotRevisionUpgradePending } from '@src/modules/platform/local-sqlite/infrastructure/snapshotRevisionGuard.ts';

export async function waitForLayoutComponent(timeoutMs = 5000): Promise<void> {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    const el = document.querySelector('layout-component');
    if (el?.isConnected) return;
    await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));
  }
}

export async function syncTelemetryUserContext(
  auth: AuthApplicationPort,
  telemetry: TelemetryPort,
  isAuth: boolean,
): Promise<void> {
  if (!isAuth) return;
  try {
    const user = await auth.getCurrentUser();
    if (user) {
      telemetry.setUserContext({ id: user.id, email: user.email, role: user.role });
    }
  } catch (e) {
    telemetry.logError('Failed to fetch user context for telemetry', { error: e });
  }
}

export function notifyPostSnapshotRevisionUpgrade(shellPorts: Pick<ShellCorePorts, 'notifications'>): void {
  if (!isSnapshotRevisionUpgradePending()) return;
  shellPorts.notifications.info(
    'Actualización de la app: sus registros locales se conservaron. Con red, vaya a Sincronizar y pulse Descargar catálogos.',
  );
}
